// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as YearFootPrint from "./YearFootPrint.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.position("absolute"),
      tl: {
        hd: BsCss.left(BsCss.px(94)),
        tl: {
          hd: BsCss.media("(min-width: 1200px)", {
                hd: BsCss.left(BsCss.px(194)),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  container: container
};

function Year2014(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(YearFootPrint.make, {
                    title: "2014",
                    subTitle: "Prezzee was founded",
                    bodyText: "Prezzee was developed by Pollen Digital in collaboration with Shaun Bonett, Edward Piazza, Roger Hatem, Claire Morris, and Matt Hoggart, collectively Prezzee’s co-founders."
                  }),
              className: container
            });
}

var make = Year2014;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
